
function customAddVariantToCart (targetIndex) {
    let formData = {
        'items': window.tlDiscounts.addToCartData[targetIndex].map((variant) => {
            return {
                'id': parseInt(variant.id),
                'quantity': parseInt(variant.quantity)
            }
        })
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(() => {
            console.log("Added gift")
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

const intervalIdSalepify = setInterval(() => {
    if (window.tlDiscounts) {
        clearInterval(intervalIdSalepify);
        window.tlDiscounts.addVariantToCart = customAddVariantToCart;
        console.log("custom volume discount salepify done");
    }
}, 100);

setTimeout(() => {
    clearInterval(intervalIdSalepify);
}, 3000)